import React from 'react'
import type { Icon } from 'shared/utils'

const Delivery = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'scooter-brun',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            viewBox="0 0 141.73 141.73"
            {...otherProps}>
            <defs></defs>
            <path
                className="Scooter_Brun_svg__cls-1"
                d="M14.67 101.67c-1.24 15.99 14.26 28.81 30.29 13.65 1.19-1.13 2.28-2.38 3.26-3.72 2.19-2.99 3.92-6.31 5.07-9.67-7.22.01-13.84-.05-21.97-.13-4.83-.04-10.24-.09-16.65-.13M99.56 94.13c-.62.04-1.33.47-2.56 1.4-.87 4.47-.63 8.77 1.14 11.97 10.22 18.55 34.03 4.19 35.97-13.96-8.22-.16-25.57.08-34.56.59M140.55 75.18c-3.35-9.06-13.17-14.09-21.66-16.29-.32-.08-.65-.16-.97-.25-3.99-6.33-7.85-11.89-11.31-18.67.36.15.77.29 1.2.39 2.83.74 6.71.58 6.69-.46-.06-4-2.87-16.5-2.95-16.9-.15-2.04-.67-2.74-2.05-3.09-.4-.11-.88-.18-1.44-.26-2.78-.36-7.3 3.87-8.18 9.69l-2.37-1.96c-.55-.43-1.28-.74-2.12-.96-3.5-.91-8.95-.15-11.12.88-4.47 2.12-3.94 8.74-.24 9.71.65.16 1.39.16 2.23-.08 1.5-.43 2.88-.48 4.16-.14 3.81.98 6.58 5.35 8.05 13.24.9 4.88 2.15 8.54 2.56 10.75-7.19 2.66-14.61 9.49-19.34 17.03-5.18 2.62-13.16-1.85-14.75-4.01-2.62-3.54-4.08-11.63 3.66-19.4 2.33-2.35.33-6.62-2.21-7.28-.07-.02-.13-.03-.19-.04-12.67-2.31-23.37-1.93-36.55-2.32-4.76-.14-7.38 6.48-4.53 8.97-7.91 2.45-10.36 3.47-15.22 8.17-5.18 5-8.9 11.48-10.77 18.81-.69 2.71-.84 5.95.47 8.33 1.13 2.06 2.88 3.08 4.83 3.59 1.57.4 3.25.48 4.85.49 2.72.02 5.21.04 7.61.05l3.59.03c1.16 0 2.26.02 3.35.02.57 0 1.18.01 1.73.02 3.64.03 6.94.06 10.06.09h.28l3.58.03c.35 0 .71.01 1.06.01.95 0 1.9.01 2.83.02h1.3c1.18 0 2.37.01 3.56.01H54.85c7.52-.02 15.83-.12 27.38-.36 7.23.51 9.59-7 16.85-7.42.93-.05 2-.1 3.07-.14.57-.03 1.13-.05 1.74-.08.83-.03 1.72-.06 2.61-.09l1.77-.06c1.15-.04 2.34-.07 3.53-.09.46-.01.9-.03 1.35-.04 1.49-.03 3-.05 4.5-.08l2.31-.03 2.46-.03c.77 0 1.51-.01 2.25-.01.75 0 1.49-.01 2.21-.01H130.9c.67 0 1.32.01 1.91.02 1 .01 1.97.03 2.75.05 5.86.16 8.99.94 5-9.86"
            />
        </svg>
    )
}

export { Delivery }
